import Vue from 'vue'
import VueRouter from 'vue-router'
import Vuex from "vuex"

// VUE must know it´s going to us vuex.
Vue.use(Vuex);

Vue.filter('currency', function (value) {
  return '$' + parseFloat(value).toFixed(2);
});

import { store } from "./store/init";

import NotFound from './components/NotFound.vue'
import Prepare from './components/Prepare.vue'
import Paypal from './components/Paypal.vue'
import Loading from './components/Loading.vue'

Vue.use(VueRouter)

import App from './App.vue'

require('./apiConfig.js')

const routes = [
  { path: '*', component: NotFound },
  { path: '/prepare/:id_pedido/:token', component: Prepare },
  {
    path: '/Loading',
    component: Loading
  },
  {
    path: '/pay',
    component: Paypal
  }
]

const router = new VueRouter({
  routes // short for `routes: routes`
})

new Vue({
  router,
  store,
  el: '#app',
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js